
import React, { Component}  from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import RestoreIcon from '@material-ui/icons/Restore';

import { ContextWidget } from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import { InputWidgetArray } from 'form/InputWidgetArray';


const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledContactPersonForm = styled.div`
  margin-bottom: 10px;
`;

const StyledHeader = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 24px auto 1fr;
  align-items: center;
  margin-bottom: 10px;
  
  h3 {
    margin: 0;
    padding: 0;
    font-size: 16px;
  }
`;

const StyledBody = styled.div`
  margin-left: 10px;
  padding: 20px 0px 0 20px;
`;


export class ContactPersonForm extends Component {

  remove = () => {
    const { contact, context, counterpartyIndex, index } = this.props;
    if (contact.id) {
      context.setValue(`${this.fieldPath()}.is_delete`, true);
    }
    else {
      context.removeArrayValue(`counterparties.${counterpartyIndex}.contacts`, index)
    }
  };

  restore = () => {
    const { context } = this.props;
    context.setValue(`${this.fieldPath()}.is_delete`, false);
  };

  fieldPath = () => {
    const { counterpartyIndex, index } = this.props;
    return `counterparties.${counterpartyIndex}.contacts.${index}`;
  };

  render() {
    const { context, counterpartyIndex, index } = this.props;
    const fieldPath = this.fieldPath();
    const item = context.getValue(fieldPath);

    return (
      <StyledContactPersonForm>
        <StyledHeader>
          <div>
            <Index>{index + 1}</Index>
          </div>
          <h3>Контактное лицо</h3>
          <div>
          {item.is_delete && (
            <Button
              size="small"
              onClick={() => this.restore()}
              startIcon={<RestoreIcon />}
            >
              Восстановить
            </Button>
          )}

            {!item.is_delete && (
              <React.Fragment>
              {(index !== 0 || context.item.counterparties[counterpartyIndex].contacts.length > 1) && (
                <IconButton size="small" onClick={() => this.remove()}>
                  <ClearIcon />
                </IconButton>
              )}
              </React.Fragment>
            )}
          </div>
        </StyledHeader>
        {!item.is_delete && (
          <StyledBody>
            <ContextWidget
              name={`${fieldPath}.name`}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'ФИО',
                required: true
              }}
            />

            <ContextWidget
              name={`${fieldPath}.phone`}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'Телефон'
              }}
            />

            <ContextWidget
              name={`${fieldPath}.emails`}
              WidgetComponent={InputWidgetArray}
              widgetProps={{
                label: 'Электронная почта'
              }}
            />
          </StyledBody>
        )}
      </StyledContactPersonForm>
    );
  }
}
